<template>
  <a-modal
    v-model="show"
    :width="600"
    title="物流轨迹信息"
  >
    <div>
      <div class="fs-16 fs-b ">订单信息</div>
      <div class="flex flex-j-sb mt-10"><div>快递公司：{{info&&info.shipperName||'--'}}</div><div>运单编号：{{info&&info.logisticCode||'--'}} </div></div>
      <div class="fs-16 fs-b mt-30">轨迹详情</div>
      <div class="mt-10">
      <div v-if="list&&list.length>0" class=" pb-40 ">
        <div v-for="(i,index) in list" :key="index" class="trace-item ">
          <div class="flex a-center " :class="index===0?'f-c-blue':''">
            <div class="w-128">{{ i.acceptTime }}</div>
            <div class="ml-14 mr-10 fs-24 "><a-icon :type="index===0?'check-circle':'up-circle'" /></div>
            <div class="word-b flex1">{{ i.acceptStation }}</div>
          </div>
          <div v-if="index<list.length-1" class="h-line" />
        </div>
      </div>
      <div v-else >
        <div class=" pt-40  pl-108  pr-108">
          <div class="ant-empty ant-empty-normal"><div class=" t-center"><img class="w-120" src="@/assets/trace/empty@2x.png" alt=""></div><p class="ant-empty-description">暂无数据</p></div>
        
        </div>
          <div class="fs-12">
            未获取到最新轨迹路由信息，可能存在以下几种情况：<br>
            1、不同快递公司运单号录入系统的时间不一致，通常揽件后2-4小时后会产生物流轨迹；<br>
            2、您的包裹被揽件后，有可能还未录入快递公司信息系统；<br>
            3、快递单号可能有误，导致无法获得物流轨迹信息；<br>
            4、有可能轨迹路由信息更新超时，<span class="f-c-blue">请尝试刷新</span> ，如2次刷新后仍无请稍后重试。
          </div>
      </div>
      </div>
    </div>

    <div slot="footer">
      <a-button type="primary" @click="show = false">好的，我知道了</a-button>
    </div>
  </a-modal>
</template>
<script>
import About from './about'

export default {
  components:{
    About
  },
  props: {
    viz: {
      type: Boolean,
      default: false
    },
    info:{
      type:Object,
      default:null
    }
  },
  data() {
    return {
      show: this.viz,
      list:[]
    }
  },
  watch: {
    show(n) {
      this.$emit('update:viz', n)
    },
    viz(n) {
      this.show = n
      if(n){
        this.getList(this.info)
      }else{
        this.list=[]
      }
    }
  },
  methods: {
      async getList(v) {
      const res = await this.$http(this.$api.logisticsQueryRoute, {
        'waybillCode': v.logisticCode,
        'shipperCode': v.shipperCode

        //  'waybillCode': '123456',
        // 'shipperCode': 'YTO'
      })
      this.list = res && res.traces && res.traces.reverse()
    },
  },
}
</script>
<style lang="scss" scoped>
.c-tips{
    position: relative;
    .close{
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
    }
}
  .h-line{
    margin-left: 154px;
    margin-top: 2px;
    margin-bottom: 2px;
    width: 1px;
    height: 32px;
    background: rgba(0, 0, 0, 0.15);
  }
</style>
